// src/components/modals/AproveCustomizationModal.tsx
import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
  Row
} from "reactstrap";

interface AproveCustomizationModalProps {
  isOpen: boolean;
  toggle: () => void;
  conditions: string;
  setConditions: (text: string) => void;
  onConfirm: () => void;
}

const AproveCustomizationModal: React.FC<AproveCustomizationModalProps> = ({
  isOpen,
  toggle,
  conditions,
  setConditions,
  onConfirm
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className={`${localStorage.getItem("mode") ? localStorage.getItem("mode") : "light"}`}>
      <ModalHeader className="modal-header-style theme-text-color">Aprovar Customização</ModalHeader>
      <ModalBody className="modal-body-style">
        <b style={{ color: "red" }}>
          Explique para o parceiro como vai ser desenvolvida e formas de
          pagamento!
        </b>
        <Row className="mt-3 p-2">
          <Input
            type="textarea"
            rows={8}
            placeholder="Explique quais as condições, forma de pagamento e contrapropostas."
            value={conditions}
            onChange={(e) => setConditions(e.target.value)}
            className="input-modal theme-text-color"
            style={{color: 'white'}}
          />
        </Row>
      </ModalBody>
      <ModalFooter className="modal-footer-style">
        <Button color="primary" onClick={onConfirm} id="btn-aprove-task">
          Aprovar
        </Button>
        <Button color="secondary" onClick={toggle}>
          Cancelar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AproveCustomizationModal;
